var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 135.46666 135.46667",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect839",
    style: {
      fill: "#be0a26",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    d: "M 21.166667,4.2333331 H 46.566665 C 55.947732,4.2333331 63.5,11.785599 63.5,21.166666 L 63.5,63.5 v 0 l -42.333333,0 C 11.7856,63.5 4.2333331,55.947733 4.2333331,46.566667 V 21.166666 c 0,-9.381067 7.5522669,-16.9333329 16.9333339,-16.9333329 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1166",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 7.42859,
      strokeMiterlimit: 0
    },
    d: "M 331.42773 32 C 298.50431 32 272 58.504304 272 91.427734 L 272 240 L 420.57227 240 C 453.49573 240 480 213.49567 480 180.57227 L 480 91.427734 C 480 58.504304 453.49573 32 420.57227 32 L 331.42773 32 z M 338.28516 48 L 413.71484 48 C 441.57317 48 464 70.426871 464 98.285156 L 464 173.71484 C 464 201.57311 441.57317 224 413.71484 224 L 288 224 L 288 98.285156 C 288 70.426871 310.42687 48 338.28516 48 z ",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1171",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1.96548,
      strokeMiterlimit: 0
    },
    d: "m 127,87.690253 c 0,-8.710988 -7.0126,-15.723587 -15.72359,-15.723587 H 71.966666 v 39.309744 c 0,8.711 7.0126,15.72359 15.72358,15.72359 H 111.27641 C 119.9874,127 127,119.98741 127,111.27641 Z m -4.23333,1.814361 v 19.957436 c 0,7.37085 -5.93378,13.30462 -13.30462,13.30462 H 89.504616 c -7.37084,0 -13.30462,-5.93377 -13.30462,-13.30462 V 76.199999 h 33.262054 c 7.37084,0 13.30462,5.933776 13.30462,13.304615 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1173",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1.96548,
      strokeMiterlimit: 0
    },
    d: "m 47.776412,127.00001 c 8.710988,0 15.723587,-7.0126 15.723587,-15.72359 V 71.96667 H 24.19025 c -8.711,0 -15.7235902,7.012599 -15.7235902,15.723579 v 23.586171 c 0,8.71099 7.0125902,15.72359 15.7235902,15.72359 z m -1.814361,-4.23333 H 26.00461 c -7.37085,0 -13.30462,-5.93378 -13.30462,-13.30462 V 89.504619 c 0,-7.37084 5.93377,-13.30462 13.30462,-13.30462 h 33.262056 v 33.262061 c 0,7.37084 -5.933776,13.30462 -13.304615,13.30462 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.63af5595493cf6a913d42f82c94bb84b.svg";
export { ForwardRef as ReactComponent };